import React from 'react'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import { AnovaLogoSmall } from './AnovaLogo'
import TextColumn from './styled-components/TextColumn'
import { TermsOfServiceAndPrivacyPolicy } from './TermsOfServiceAndPrivacyPolicy'
import { analyticsPage } from '../analytics'

const PasswordChanged = () => {
  analyticsPage('ALI Password Reset - Success')

  return (
    <Card data-password-reset-success>
      <div>
        <AnovaLogoSmall />
      </div>

      <TextColumn>
        <HeaderText>Password Changed</HeaderText>
        <HeaderTextSmall>You can now log in with your new<br />password</HeaderTextSmall>
      </TextColumn>

      <TermsOfServiceAndPrivacyPolicy />
    </Card>
  )
}

export default PasswordChanged
